/* RESPONSIBLE TEAM: team-workflows */
import Controller from '@ember/controller';

export default class WorkflowsTroubleshootConversationsWithIdController extends Controller {
  queryParams = ['eventTypes', 'status'];
}
